<template>
    <div>
        <div class="my-5">
            <div>
                <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    Video/Playlist URL or Embed Code:
                </label>
                <input type="text" class="form-control " @change="onChange($event)"  :value="this.getActiveCanvasObjProps.url" />
            </div>
            <div class="mt-3">
                <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    Suggested Video Quality:
                </label>
                <select type="text" class="form-control ">

                    <option v-for="(option, index) of list" v-bind:key="index" :value="option.value">{{option.label}}</option>

                </select>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "YoutubeAppSettings",
    data() {
        return {
            list: [
            { value: "auto", label: "Auto" },
            { value: "720", label: "HD (720p)" },
            { value: "1080", label: "Full HD (1080p)" },
            { value: "2160", label: "4k (2160p)" },
            { value: "480", label: "480p" },
            { value: "360", label: "360p" },
            { value: "240", label: "240p" },
        ]
        }
    },
    computed:{
        getActiveCanvasObjProps(){
            return this.$store.getters.getActiveObjectprops
        },
    },
    methods:{
        onChange(e){
            debugger // eslint-disable-line no-debugger
            let value = e.target.value;

            if(value.includes("youtu.be")){
                value = "https://www.youtube.com/embed/" + value.split("/").at(-1); 
            } else if(value.includes("/watch")){
                value = "https://www.youtube.com/embed/" + value.split("&")[0].split("=").at(-1); 
            } else {
                value = e.target.value;
            }
            this.$store.dispatch("setCurrentObjectProperties" , { url: value });
        }
    }

}
</script>